/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import classnames from 'classnames';

import ProfileThemeStyles from './ProfileThemeStyles';
import SystemNotification from '../components/SystemNotification';
import KeyboardExtraBar from '../components/KeyboardExtraBar';
import SystemModal from '../components/modal/SystemModal';
import ColorThemeStyle from '../components/ColorThemeStyle';
import { SlidingAppMenu } from '../appAuthorized/appMenu/SlidingAppMenu';
import { SlidingMenuMask } from '../appAuthorized/appMenu/SlidingMenuMask';
import { AppMenu } from '../appAuthorized/appMenu/AppMenu';
import { useUIState } from '../hooks/useUIState';
import { withRouter } from 'react-router';

interface Props {
  location: any;
}
const Layout: React.FC<Props> = (props) => {
  const { children, location } = props;

  const [{ isSystemModalVisible, sliding, blurSize }, uiActions] = useUIState();
  const [isBlurred, setIsBlurred] = React.useState(Boolean(blurSize));

  const blurClassName = isBlurred && blurSize ? `util-${blurSize}` : '';
  const menuVisible = uiActions.isMenuVisible(location);
  const menuShielded = uiActions.isMenuShielded(location);
  const colorTheme = uiActions.getCurrentColorTheme();

  const styleClass = classnames('cmp-layout', blurClassName, {
    'is-blurred': isBlurred,
    'is-system-modal-visible': isSystemModalVisible,
    'has-static-menu': menuVisible,
  });

  React.useEffect(() => {
    uiActions.setWindowTitlePhrase({ id: 'app.backpack.name' });
  }, []);

  React.useEffect(() => {
    if (!blurSize && sliding) {
      // delay removing isBlurred in case of closing menu to make sliding out more smooth
      if (isBlurred) {
        setTimeout(() => {
          setIsBlurred(false);
        }, 300);
      }
    } else {
      setIsBlurred(Boolean(blurSize));
    }
  }, [blurSize]);

  return (
    <div className={styleClass}>
      <SystemModal />

      <div id="modal-root" />

      <div className={classnames('cmp-menu-container', { sliding })}>
        <ProfileThemeStyles colorTheme={colorTheme} />
        <ColorThemeStyle themeName="group" />

        {
          menuVisible &&
          <div className={classnames('cmp-static-app-menu profile-background-color-accent', { shield: menuShielded })}>
            <AppMenu avatarSize={48} />
          </div>
        }

        <SystemNotification />
        <KeyboardExtraBar contentAreaCssSelector=".cmp-scrollaware" />

        <div className="cmp-application-frame util-application-content-width-with-margin">
          {children}
        </div>

        <SlidingMenuMask />
        <SlidingAppMenu />
      </div>
    </div>
  );
};

export default withRouter(Layout);
